module.exports = __webpack_public_path__ + "front/img/edm-agenda.28567bf1.png";